import { render, staticRenderFns } from "./comp-cdn-stream.vue?vue&type=template&id=518c825b&scoped=true&lang=pug&"
import script from "./comp-cdn-stream.vue?vue&type=script&lang=js&"
export * from "./comp-cdn-stream.vue?vue&type=script&lang=js&"
import style0 from "./comp-cdn-stream.vue?vue&type=style&index=0&id=518c825b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518c825b",
  null
  
)

export default component.exports